export default __webpack_public_path__ + "static/media/mw14.78407324.webp";